<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="organização,organizações;a"
    icon="mdi-laptop"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todas as orgs' : '(Todas)'"
    types="grouped-items"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { Org } from '@/models'
import { orderBy, hasTag } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Organização' },
    orientation: { type: String, default: 'horizontal' },
    useCodes: { type: Boolean, default: false },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = await Org.findAll()
      rows = rows.filter((r) => r.id != -1 && hasTag(r.extraInfo, 'PRD'))
      rows = rows.map((r) => {
        let id = this.useCodes ? r.name : r.id
        let name = r.label
        return { id, name }
      })
      this.allItems = orderBy(rows, [['name', 'asc']])
    }
  }
}
</script>

<style></style>
